import { render, staticRenderFns } from "./control-master-update.vue?vue&type=template&id=3115bafa&scoped=true&"
import script from "./control-master-update.vue?vue&type=script&lang=js&"
export * from "./control-master-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3115bafa",
  null
  
)

export default component.exports